import React from 'react';
import MotifFormField from '@ey/motif-react-wrapper/FormField';

export default function FormField(props) {
	const {children, ...rest} = props;

	return <MotifFormField {...rest}>{children}</MotifFormField>;
}
